/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Modules_HintInputs */

const cs_clients_create_modules_hint = /** @type {(inputs: Clients_Create_Modules_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po vytvoření doplníte poptávky, investorský profil a vlastnictví na kartě klienta.`)
};

const en_clients_create_modules_hint = /** @type {(inputs: Clients_Create_Modules_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After create you can fill demands, investor profile, and ownership on the client card.`)
};

/**
* | output |
* | --- |
* | "After create you can fill demands, investor profile, and ownership on the client card." |
*
* @param {Clients_Create_Modules_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_create_modules_hint = /** @type {((inputs?: Clients_Create_Modules_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Modules_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_modules_hint(inputs)
	return cs_clients_create_modules_hint(inputs)
});